module.exports = __webpack_public_path__ + "img/img11.acab7400.jpg";